import homeBR from './home.br';
import homeMX from './home.mx';
import homeCL from './home.cl';
import homeCO from './home.co';

const home = {
  BR: homeBR,
  MX: homeMX,
  CL: homeCL,
  CO: homeCO,
};

export default home;
